import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { getCooperationChannel } from "@/data";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CooperactionChannel',
  setup(__props) {

const contentHtml = ref("");
getCooperationChannel().then((res) => {
  contentHtml.value = res.data.data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title)
    }, "金丰科技信息（深圳）集团有限公司", 2),
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.content),
      innerHTML: contentHtml.value
    }, null, 10, _hoisted_1)
  ], 64))
}
}

})